/* Gelübde-Konfigurator
 * Unterer Druck (Namen + Datum in Minion Pro) live auf dem
 * Büttenpapier-Mockup mit gedrucktem Kopf.
 */
(function () {
  'use strict';

  var GHOST_NAMEN = 'Julia & Alex';

  function boot() {
    var fields = document.querySelector('[data-geluebde-vorschau]');
    var wrap = document.querySelector('[data-geluebde-stage-wrap]');
    if (!fields || !wrap || wrap.dataset.geluebdeInit) return;
    wrap.dataset.geluebdeInit = '1';

    var stage = wrap.querySelector('[data-geluebde-stage]');
    var namenEl = wrap.querySelector('[data-geluebde-text-namen]');
    var datumEl = wrap.querySelector('[data-geluebde-text-datum]');
    var textBox = wrap.querySelector('.geluebde-stage__text');
    var namenInput = fields.querySelector('[data-geluebde-namen]');
    var datumInput = fields.querySelector('[data-geluebde-datum]');
    var showLink = fields.querySelector('[data-geluebde-show]');

    function layoutStage() {
      var w = stage.clientWidth;
      var h = stage.clientHeight;
      if (!w || !h) return 0;
      var s = Math.min(w, h);
      wrap.style.setProperty('--is', s + 'px');
      wrap.style.setProperty('--ix', (w - s) / 2 + 'px');
      wrap.style.setProperty('--iy', '0px');
      return s;
    }

    function render() {
      var imgSize = layoutStage() || stage.clientWidth;
      var namen = namenInput.value.trim() || GHOST_NAMEN;
      var datum = datumInput.value.trim();
      namenEl.textContent = namen;
      datumEl.textContent = datum;
      datumEl.style.display = datum ? '' : 'none';

      var size = imgSize * 0.030;
      var min = 9;
      namenEl.style.fontSize = size + 'px';
      datumEl.style.fontSize = Math.max(size * 0.62, 9) + 'px';
      var guard = 20;
      while (guard-- > 0 && size > min && namenEl.scrollWidth > textBox.clientWidth) {
        size -= 1;
        namenEl.style.fontSize = size + 'px';
      }

      textBox.style.opacity = namenInput.value.trim() || datum ? '1' : '0.5';
    }

    function open() {
      wrap.classList.add('is-open');
      render();
    }

    wrap.querySelector('[data-geluebde-close]').addEventListener('click', function () {
      wrap.classList.remove('is-open');
    });

    /* Leere Felder nicht als Property mitbestellen */
    function syncNames() {
      if (namenInput.value.trim()) namenInput.setAttribute('name', 'properties[Namen]');
      else namenInput.removeAttribute('name');
      if (datumInput.value.trim()) datumInput.setAttribute('name', 'properties[Datum]');
      else datumInput.removeAttribute('name');
    }

    namenInput.addEventListener('focus', open);
    datumInput.addEventListener('focus', open);
    namenInput.addEventListener('input', function () { syncNames(); render(); });
    datumInput.addEventListener('input', function () { syncNames(); render(); });
    if (showLink) {
      showLink.addEventListener('click', function () {
        open();
        wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    }
    wrap.querySelector('[data-geluebde-img]').addEventListener('load', render);
    window.addEventListener('resize', render);

    syncNames();
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
